import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import cx from 'classnames';
import PrismicConditionalLink from 'components/PRISMIC/PrismicConditionalLink';
import styles from 'components/PRISMIC/scss/pages.module.scss';

import type { JSX } from 'react';

/**
 * Props for `Button`.
 */
export type ButtonProps = SliceComponentProps<Content.ButtonSlice>;

export const PageBuilderButton = ({
  isDark = false,
  children,
  ...props
}: {
  isDark?: boolean;
  children: React.ReactNode;
}) => (
  <span
    className={cx(
      styles.button,
      styles['pages-button'],
      '[&_a]:no-underline',
      isDark && styles['button--dark']
    )}
    {...props}
  >
    {children}
  </span>
);

/**
 * Component for "Button" Slices.
 */
const Button = ({ slice }: ButtonProps): JSX.Element => {
  return (
    <PrismicConditionalLink field={slice.primary.link}>
      <PageBuilderButton
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        isDark={slice.primary.style === 'dark'}
      >
        <PrismicRichText
          field={slice.primary.label}
          components={{
            paragraph: ({ children }) => <>{children}</>
          }}
        />
      </PageBuilderButton>
    </PrismicConditionalLink>
  );
};

export default Button;
